module.exports = __webpack_public_path__ + "static/media/arrow-back.5cb1c51c.svg";